// File Metadata:
// Filename: crossdockApiSlice.js
// Version: 1.00
// Created: 2025-03-22 00:05:50
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { apiSlice } from '../../app/api/apiSlice'

export const crossdockApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCrossdocks: builder.query({
            query: () => '/crossdock',
            providesTags: ['Crossdock']
        }),
        addNewArrival: builder.mutation({
            query: initialData => ({
                url: '/crossdock/arrival',
                method: 'POST',
                body: initialData
            }),
            invalidatesTags: ['Crossdock']
        }),
        addNewDeparture: builder.mutation({
            query: ({ id, departureData }) => ({
                url: `/crossdock/${id}/departure`,
                method: 'PATCH',
                body: departureData
            }),
            invalidatesTags: ['Crossdock']
        }),
        getPendingHUs: builder.query({
            query: () => '/crossdock/pending',
            providesTags: ['Crossdock']
        }),
        getPendingHUsByTour: builder.query({
            query: (tourNumber) => `/crossdock/pending/${tourNumber}`,
            providesTags: ['Crossdock']
        }),
        updateCrossdock: builder.mutation({
            query: ({ id, ...changes }) => ({
                url: `/crossdock/${id}`,
                method: 'PATCH',
                body: changes
            }),
            invalidatesTags: ['Crossdock']
        }),
        deleteCrossdock: builder.mutation({
            query: ({ id }) => ({
                url: `/crossdock/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Crossdock']
        }),
        getPendingDepartures: builder.query({
            query: () => '/crossdock/pending-departures',
            providesTags: ['Crossdock']
        })
    })
})

export const {
    useGetCrossdocksQuery,
    useAddNewArrivalMutation,
    useAddNewDepartureMutation,
    useGetPendingHUsQuery,
    useGetPendingHUsByTourQuery,
    useUpdateCrossdockMutation,
    useDeleteCrossdockMutation,
    useGetPendingDeparturesQuery
} = crossdockApiSlice
